import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/carPlateMatchRule/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/carPlateMatchRule/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/carPlateMatchRule/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/carPlateMatchRule/save/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/carPlateMatchRule/update/v2', params, options);

export const sync = (params, options) =>
  request.post('/api/v4ward/carPlateMatchRule/sync/v2', qs.stringify(params), options);

export const updateStatus = (params, options) =>
  request.post('/api/v4ward/carPlateMatchRule/updateStatus/v2', params, options);

export const getCarParkList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/getCarParkList/v2', Object.assign({}, options, {
    params
  }));
